export default __webpack_public_path__ + "static/media/airplane_light.4fed5179.png";